<template>
    <div class="blog">
        <section class="relative h-96">
            <div class="absolute inset-0">
                <img src="@/assets/images/testing.png" alt="University Background" class="object-cover w-full h-full" />
                <div class="absolute inset-0 bg-black opacity-50"></div> <!-- Dark overlay -->
            </div>
            <div class="relative z-10 flex flex-col items-center justify-center h-full px-4 text-center text-white">
                <br><br><br><br>
                <div class="flex w-full max-w-2xl p-2 px-4 space-x-4 rounded-full shadow-lg journey_div">
                    <input type="text" placeholder="Search Articles"
                        class="flex-1 px-4 py-2 border-none rounded-full form-select focus:ring-0 focus:outline-none" />
                    <button
                        class="flex items-center px-8 py-2 text-white transition duration-300 rounded-full bg-purple hover:bg-purple-800">
                        Search
                        <i class="ml-2 fas fa-search"></i>
                    </button>
                </div>
            </div>
        </section>


        <section class="p-10 bg-purple">
            <div class="w-4/5 mx-auto">
                <h2 class="text-2xl font-bold text-white">Popular Articles</h2>
                <div class="w-32 mb-6 border-b-2 border-white"></div>
                <div class="container grid grid-cols-3 gap-8 mx-auto">
                    <!-- Main Article (Left Column) -->
                    <div class="col-span-2">
                        <div class="overflow-hidden rounded-lg ">
                            <img src="@/assets/images/article1.png" alt="Main Article Image"
                                class="object-cover w-full h-64">
                            <div class="p-6">
                                <p class="mb-2 text-white">October 29, 2024</p>
                                <h3 class="mb-4 text-xl font-bold text-white">Lorem Ipsum Dolor Sit</h3>
                                <p class="leading-relaxed text-white">
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                                    incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur
                                    adipiscing elit, sed do eiusmod tempor.
                                </p>
                            </div>
                        </div>
                    </div>

                    <!-- Smaller Articles (Right Column) -->
                    <div class="space-y-6">
                        <div class="flex space-x-4">
                            <img src="@/assets/images/article2.png" alt="Article 1"
                                class="object-cover w-24 h-24 rounded-lg">
                            <div>
                                <p class="mb-1 text-sm text-gray-300">October 29, 2024</p>
                                <h6 class="text-white">Lorem Ipsum Dolor Sit Amet, Consectetur Adipiscing
                                    Elit,
                                    Sed Do Eiusmod Tempor</h6>
                            </div>
                        </div>

                        <div class="flex space-x-4">
                            <img src="@/assets/images/article3.png" alt="Article 2"
                                class="object-cover w-24 h-24 rounded-lg">
                            <div>
                                <p class="mb-1 text-sm text-gray-300">October 29, 2024</p>
                                <h6 class="text-white">Lorem Ipsum Dolor Sit Amet, Consectetur Adipiscing
                                    Elit,
                                    Sed Do Eiusmod Tempor</h6>
                            </div>
                        </div>

                        <div class="flex space-x-4">
                            <img src="@/assets/images/article4.png" alt="Article 3"
                                class="object-cover w-24 h-24 rounded-lg">
                            <div>
                                <p class="mb-1 text-sm text-gray-300">October 29, 2024</p>
                                <h6 class="text-white">Lorem Ipsum Dolor Sit Amet, Consectetur Adipiscing
                                    Elit,
                                    Sed Do Eiusmod Tempor</h6>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </section>


        <section class="w-4/5 p-10 mx-auto">
            <div class="mx-auto max-w-7xl">
                <!-- Section Title -->
                <h3 class="text-2xl text-gray-800">Latest Articles</h3>
                <div class="w-32 mb-6 border-b-2 border-purple"></div>
                <!-- Articles Grid -->
                <div class="grid grid-cols-3 gap-8">
                    <div class="overflow-hidden bg-white rounded-lg shadow-md">
                        <img src="@/assets/images/latest_article1.png" alt="Article Image"
                            class="object-cover w-full h-40">
                        <div class="p-4">
                            <p class="text-sm text-gray-500">October 29, 2024</p>
                            <div class="w-24 mb-1 border-b-2 border-purple"></div>
                            <h5 class="mb-2 text-gray-800">Lorem Ipsum Dolor Sit</h5>
                            <p class="text-sm text-gray-600">Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                                sed do eiusmod tempor.</p>
                        </div>
                    </div>

                    <!-- Article Card 2 -->
                    <div class="overflow-hidden bg-white rounded-lg shadow-md">
                        <img src="@/assets/images/latest_article2.png" alt="Article Image"
                            class="object-cover w-full h-40">
                        <div class="p-4">
                            <p class="text-sm text-gray-500">October 29, 2024</p>
                            <div class="w-24 mb-1 border-b-2 border-purple"></div>
                            <h5 class="mb-2 text-gray-800">Lorem Ipsum Dolor Sit</h5>
                            <p class="text-sm text-gray-600">Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                                sed do eiusmod tempor.</p>
                        </div>
                    </div>

                    <!-- Article Card 3 -->
                    <div class="overflow-hidden bg-white rounded-lg shadow-md">
                        <img src="@/assets/images/latest_article3.png" alt="Article Image"
                            class="object-cover w-full h-40">
                        <div class="p-4">
                            <p class="text-sm text-gray-500">October 29, 2024</p>
                            <div class="w-24 mb-1 border-b-2 border-purple"></div>
                            <h5 class="mb-2 text-gray-800">Lorem Ipsum Dolor Sit</h5>
                            <p class="text-sm text-gray-600">Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                                sed do eiusmod tempor.</p>
                        </div>
                    </div>

                    <!-- Article Card 4 -->
                    <div class="overflow-hidden bg-white rounded-lg shadow-md">
                        <img src="@/assets/images/latest_article4.png" alt="Article Image"
                            class="object-cover w-full h-40">
                        <div class="p-4">
                            <p class="text-sm text-gray-500">October 29, 2024</p>
                            <div class="w-24 mb-1 border-b-2 border-purple"></div>
                            <h5 class="mb-2 text-gray-800">Lorem Ipsum Dolor Sit</h5>
                            <p class="text-sm text-gray-600">Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                                sed do eiusmod tempor.</p>
                        </div>
                    </div>

                    <!-- Article Card 5 -->
                    <div class="overflow-hidden bg-white rounded-lg shadow-md">
                        <img src="@/assets/images/latest_article5.png" alt="Article Image"
                            class="object-cover w-full h-40">
                        <div class="p-4">
                            <p class="text-sm text-gray-500">October 29, 2024</p>
                            <div class="w-24 mb-1 border-b-2 border-purple"></div>
                            <h5 class="mb-2 text-gray-800">Lorem Ipsum Dolor Sit</h5>
                            <p class="text-sm text-gray-600">Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                                sed do eiusmod tempor.</p>
                        </div>
                    </div>

                    <!-- Article Card 6 -->
                    <div class="overflow-hidden bg-white rounded-lg shadow-md">
                        <img src="@/assets/images/latest_article6.png" alt="Article Image"
                            class="object-cover w-full h-40">
                        <div class="p-4">
                            <p class="text-sm text-gray-500">October 29, 2024</p>
                            <div class="w-24 mb-1 border-b-2 border-purple"></div>
                            <h5 class="mb-2 text-gray-800">Lorem Ipsum Dolor Sit</h5>
                            <p class="text-sm text-gray-600">Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                                sed do eiusmod tempor.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="flex flex-col items-center justify-center p-10">
            <!-- Heading -->
            <h3 class="mb-4 text-xl">Join Our Newsletter!</h3>

            <!-- Newsletter Form -->
            <div class="flex items-center overflow-hidden border border-gray-400 rounded-full shadow-lg">
                <!-- Input Field -->
                <input type="email" placeholder="Type your email address"
                    class="px-4 py-3 text-gray-600 border-0 w-80 focus:outline-none focus:ring-0" />

                <!-- Submit Button -->
                <button class="flex items-center px-6 py-2 text-white bg-purple-700 rounded-full hover:bg-purple-800" style="margin-right: 14px;">
                    Join Now
                    <i class="ml-2 fas fa-arrow-right"></i>
                </button>
            </div>
        </section>

    </div>
</template>

<script>

export default {
    name: 'Blog',

}
</script>

<style scoped>
.journey_div {
    background: transparent;
    border: 2px solid #fff;
}

.below_line {
    font-weight: bold;
    border-top-width: 2px !important;
}

.form-select {
    appearance: none;
    background: transparent;
    color: #fff;
    padding: 8px;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
}

.bg-lightPurple {
    background-color: #f3e1f5;
}

.bg-purple-700 {
    background-color: #800080;
}

.bg-purple-800 {
    background-color: #660066;
}

.shadow-lg {
    box-shadow: 0 10px 15px rgba(0, 0, 0, 0.1);
}
</style>